<template>
  <section class='p-1'>
    <section class='resume mb-4'>
      <p class='resume-title'>Plano mensal — resumo da sua contratação:</p>

      <ul class='resume-list'>
        <li>
          <strong>Valor: {{ formatRealCurrent(getPlan.value) }}/mês</strong>, cobrado hoje e a cada 30 dias
          (<strong>assinatura recorrente</strong>); Reforçamos que a assinatura mensal é
          <strong>cobrada de forma automática todo mês</strong> a menos que cancelada de forma manual.
        </li>
        <li>
          <strong>Consultas:</strong> até <strong>{{ getPlan.chemicalAgentsLimit }} agentes químicos por mês</strong> (contados pelo CAS ou agente);
        </li>
        <li>
          <strong>Seu preço não sobe:</strong> enquanto sua assinatura estiver ativa e sem interrupção, desde que este
          plano esteja vigente, valor permanece o mesmo;
        </li>
        <li>
          <strong>Cancelamento a qualquer momento, sem multas ou burocracias:</strong> Você pode cancelar a qualquer
          momento na sua área do assinante ou enviando e-mail com solicitação para faleconosco@hofacilweb.com.br;
        </li>
        <li>
          <strong>Garantia de {{ getPlan.refundDays }} dias com reembolso de 100% do valor caso esteja cancelando em até {{ getPlan.refundDays }} dias</strong>
          corridos a partir da data da assinatura/adesão;
        </li>
        <li>
          Este plano mantém todas as funcionalidades existentes na contratação.
          <strong>Novas funcionalidades são liberadas apenas no Plano Anual.</strong>
        </li>
      </ul>
    </section>

    <section class='buttons d-flex justify-content-between align-items-center'>
      <base-button
        class='nav-btn'
        dark
        @click="$emit('back-step')"
      >
        Voltar
      </base-button>

      <base-button
        class='nav-btn'
        @click='next()'
      >
        Concordo e desejo continuar
      </base-button>
    </section>

  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatRealCurrent } from '@/utils/format'

export default {
  name: 'Validation',
  computed: {
    ...mapGetters('checkout2', {
      getPlan: 'getPlan'
    })
  },
  methods: {
    formatRealCurrent,
    async next() {
      this.$emit('next-step')
    },
    async back() {
      await this.$router.push('/planos')
    }
  }
}
</script>

<style lang='scss' scoped>
.buttons {
  margin-top: 24px;
}

.nav-btn {
  min-width: 140px;
  padding: 12px 20px;
}

.resume {
  background: #eef1f6;
  border-radius: 8px;
  padding: 24px 28px;
  color: #1c2439;
}

.resume-title {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
}

.resume-list {
  margin: 0;
  padding-left: 20px;

  li {
    font-size: 15px;
    line-height: 1.5;
    margin-bottom: 14px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
